import React, { useContext } from "react";
import { Input } from "rsuite";
import "./index.css";
import { ConfiguracaoGlebaContext } from "../../../../../../contexts/ConfiguracaoGlebaContext";

function Observacoes() {
  const {
    configuracaoGleba,
    setConfiguracaoGleba,
    activeCulturaIndex,
    setProgramacaoAlterada,
  } = useContext(ConfiguracaoGlebaContext);
  // Observação é POR CULTIVAR (fica na cultura da aba ativa).
  const handleChange = (observacoes) => {
    setProgramacaoAlterada(true);
    setConfiguracaoGleba((prevState) => {
      const culturas = [...(prevState.culturas || [])];
      if (culturas[activeCulturaIndex]) {
        culturas[activeCulturaIndex] = {
          ...culturas[activeCulturaIndex],
          observacoes,
        };
      }
      return { ...prevState, culturas };
    });
  };
  return (
    <div className="table-responsive">
      <div className="title-card">OBSERVAÇÕES</div>
      <Input
        style={{ width: "60%", margin: "10px" }}
        as="textarea"
        value={configuracaoGleba?.culturas?.[activeCulturaIndex]?.observacoes}
        rows={3}
        placeholder="Observações"
        onChange={handleChange}
      />
    </div>
  );
}

export default Observacoes;
